import { DownOutlined, RightOutlined } from '@ant-design/icons'
import { useState } from 'react'

import AtomCheckbox from '@/components/Atoms/AtomCheckbox/AtomCheckbox'

import cn from '../../StockImportsTab/StockImportsTab.module.scss'
import { getExcelColumnName } from '../UrlExcelMapper/UrlExcelMapper.types'
import type { SegmentColumnsContextValue } from './SegmentColumnsContext'

type SegmentPriceOptionProps = {
  columnIndex: number
  segmentColumns: SegmentColumnsContextValue
  isOrganisationSelected: boolean
  onSelectionChange: (segmentIds: string[]) => void
}

const findSegmentColumn = (
  segmentIdsByColumn: Record<number, string[]>,
  segmentId: string
) =>
  Object.entries(segmentIdsByColumn).find(([, ids]) =>
    ids.includes(segmentId)
  )?.[0]

function SegmentPriceOption({
  columnIndex,
  segmentColumns,
  isOrganisationSelected,
  onSelectionChange,
}: SegmentPriceOptionProps) {
  const selectedIds = segmentColumns.segmentIdsByColumn[columnIndex] ?? []
  const [expanded, setExpanded] = useState(selectedIds.length > 0)

  const toggleSegment = (segmentId: string, checked: boolean) =>
    onSelectionChange(
      checked
        ? [...selectedIds, segmentId]
        : selectedIds.filter((id) => id !== segmentId)
    )

  return (
    <div
      className={cn.urlExcelSegmentOption}
      onMouseDown={(event) => event.preventDefault()}
    >
      <button
        type="button"
        className={cn.urlExcelSegmentToggle}
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
      >
        {expanded ? (
          <DownOutlined aria-hidden />
        ) : (
          <RightOutlined aria-hidden />
        )}
        Цена по сегменту
      </button>
      {expanded && (
        <div className={cn.urlExcelSegmentList}>
          {segmentColumns.segments.map((segment) => {
            const otherColumn = findSegmentColumn(
              segmentColumns.segmentIdsByColumn,
              segment.id
            )
            const isTaken =
              otherColumn !== undefined && Number(otherColumn) !== columnIndex

            return (
              <AtomCheckbox
                key={segment.id}
                checked={selectedIds.includes(segment.id)}
                disabled={isTaken}
                isOrganisationSelected={isOrganisationSelected}
                onChange={(checked) => toggleSegment(segment.id, checked)}
              >
                {isTaken
                  ? `${segment.label} (колонка ${getExcelColumnName(Number(otherColumn))})`
                  : segment.label}
              </AtomCheckbox>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default SegmentPriceOption
